import { createFileRoute } from "@tanstack/react-router"
import { projectSettingsViewStaticData } from "src/views/ProjectSettingsView/constants"
import { ProjectSettingsView } from "src/views/ProjectSettingsView/ProjectSettingsView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/projects/")({
	component: ProjectSettingsView,
	staticData: projectSettingsViewStaticData,
})
